import React, { useState, useEffect, } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Tabs } from 'antd';
import PageHeader from '../../../components/helpers/page.header';
import { useNavigate, useParams, } from 'react-router';

import { UserIcon, ShieldCheckIcon, UsersThreeIcon, PaletteIcon, MapPinLineIcon, ChartLineUpIcon, UserPlusIcon, GearIcon, } from "@phosphor-icons/react";

import { ProtectedLayout, } from './../../../components/layouts';
import { UsersView, } from '../../../components/users';

import ProfileFinancialView from './profile.financial.view';
import ProfileSecurityView from './profile.security.view';
import ProfileDetailView from './profile.detail.view';
import ProfileCustomerView from './profile.customer.view';
import ProfileInviteView from './profile.invite.view';
import ProfileSettingsView from './profile.settings.view';

import SettingsCustomerBrandingView from '../../settings/views/settings.customer.branding.view';

const ProfileDetailPage = ({
    ...props
}) => {

    const [pagetab, setPagetab] = useState();
    const history = useNavigate();
    const localdata = sessionStorage.getItem('authentication');
    const idToken = JSON.parse(localdata);
    const { vendor_id, } = idToken || {};
    const { tab } = useParams();
    // const { userPermissions: { profile_users, profile_finance, } } = props || {};

    useEffect(() => {
        if (tab) {
            setPagetab(tab);
        }
    }, [tab]);

    // below item is only AVAILABLE for the root user (vendor_id === 0) to customize the root account branding.
    const root_tab_items = {
        label: <><PaletteIcon size={16} weight="light" /> <FormattedMessage id="customer-branding" /></>,
        key: "branding",
        children: <SettingsCustomerBrandingView history={history} customerID="me" />,
    };

    const tabItems = [
        {
            label: <><UserIcon size={18} weight="light" /> <FormattedMessage id="profile-myinfo" /></>,
            key: "me",
            children: <ProfileDetailView history={history} {...props} />
        },
        {
            label: <><MapPinLineIcon size={18} weight="light" /> <FormattedMessage id="customer-myinfo" /></>,
            key: "detail",
            children: <ProfileCustomerView history={history} {...props} />
        },
        {
            label: <><GearIcon size={18} weight="light" /> <FormattedMessage id="my-settings" /></>,
            key: "settings",
            children: <ProfileSettingsView history={history} {...props} />
        },
        {
            label: <><ShieldCheckIcon size={18} weight="light" /> <FormattedMessage id="profile-security" /></>,
            key: "security",
            children: <ProfileSecurityView history={history} {...props} />
        },
        {
            label: <><UsersThreeIcon size={18} weight="light" /> <FormattedMessage id="profile-myusers" /></>,
            key: "users",
            children: <UsersView history={history} {...props} />
        },
        {
            label: <><UserPlusIcon size={16} className="mr-1" /> <FormattedMessage id="profile-invite" /></>,
            key: "invite",
            children: <ProfileInviteView history={history} />
        },
        {
            label: <><ChartLineUpIcon size={18} weight="light" /> <FormattedMessage id="profile-finance" /></>,
            key: "finance",
            children: <ProfileFinancialView history={history} customerID="me" {...props} />
        },

        vendor_id === "0" && { ...root_tab_items }
    ];

    return (
        <ProtectedLayout {...props} history={history}>

            <Row gutter={[32, 32]}>
                <Col span={24}>
                    <PageHeader
                        className="site-page-header"
                        onBack={() => window.history.back()}
                        title={<FormattedMessage id="profile-details-page-header" />}
                        subTitle={<FormattedMessage id="profile-details-page-header-info" />}
                        ghost={false}
                    />
                </Col>

                {/* Tab container */}
                <Col span={24} className="">

                    {/* Tabs selctions */}
                    <Tabs
                        defaultActiveKey="me"
                        activeKey={pagetab}
                        onChange={e => setPagetab(e)}
                        items={tabItems.filter(Boolean)}
                    />

                </Col>
            </Row>

        </ProtectedLayout>
    );
};

export default ProfileDetailPage;